import { useRef, useState } from 'preact/hooks'

export interface EtatEasterEggDemo {
  disponible: boolean
  actif: boolean
  cycles_utilises?: number
}

interface EasterEggDemoProps {
  etat: EtatEasterEggDemo
  onDesactiver: () => Promise<void>
}

/** L'état persistant et le compteur de cycles viennent exclusivement du serveur. */
export function EasterEggDemo({ etat, onDesactiver }: EasterEggDemoProps) {
  const [enCours, setEnCours] = useState(false)
  const [erreur, setErreur] = useState('')
  const requeteEnCours = useRef(false)

  async function desactiver() {
    if (requeteEnCours.current) return
    requeteEnCours.current = true
    setEnCours(true)
    setErreur('')
    try {
      await onDesactiver()
    } catch {
      setErreur('Les couleurs restent pour le moment. Tu peux réessayer.')
    } finally {
      requeteEnCours.current = false
      setEnCours(false)
    }
  }

  if (!etat.disponible || !etat.actif) return null

  return (
    <section class="ux-demo-easter-egg" aria-label="Surprise de la démo">
      <div class="ux-demo-easter-egg__texte">
        <p class="ux-demo-easter-egg__titre" role="status">
          Troisième tournée ? On te déroule l’arc-en-ciel{' '}
          <span aria-hidden="true">🌈</span>
        </p>
        <p class="ux-demo-easter-egg__description">
          Tu connais le chemin : Funo a sorti toutes ses couleurs. Tout fonctionne
          comme d’habitude.
        </p>
        <p class="ux-demo-easter-egg__erreur" aria-live="polite">
          {erreur}
        </p>
      </div>
      <button
        type="button"
        class="ux-demo-easter-egg__retour"
        onClick={() => void desactiver()}
        disabled={enCours}
        aria-busy={enCours}
      >
        {enCours
          ? 'Retour aux couleurs normales…'
          : 'Revenir aux couleurs normales'}
      </button>
    </section>
  )
}
